import styled from "styled-components";

export const Sections = styled.div`
  display: flex;
  padding: 2% 4%;

  @media (max-width: 750px) {
    flex-direction: column;
  }
`;

export const CenterPageSection = styled.div`
  width: 70%;
  display: inline-block;
  margin-bottom: 1%;
  margin-right: 1%;

  @media (max-width: 1100px) {
    width: 75%;
  }

  @media (max-width: 750px) {
    order: 1;
    width: 100%;
    float: none;
  }
`;

export const LeftPageSection = styled.div`
  background-color: #fce8ef;
  display: inline-block;
  margin-bottom: 1%;
  width: 25%;

  @media (max-width: 1100px) {
    width: 18%;
  }

  @media (max-width: 750px) {
    order: 2;
    width: 100%;
  }
`;

export const RightPageSection = styled.div`
  width: 30%;
  margin-left: 2%;
  margin-bottom: 1%;
  display: inline-block;

  @media (max-width: 1100px) {
    width: 25%;
    margin-left: 0%;
  }

  @media (max-width: 750px) {
    width: 100%;
    order: 2;
  }
`;
